import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireActive = true, adminOnly = false, allowTrial = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === undefined) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-gold" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  // Trial users are allowed into trial-accessible routes (they still see the upgrade gate on member-only pages).
  if (user.role === "trial") {
    if (allowTrial || !requireActive) return children;
    return <Navigate to="/dashboard" replace />;
  }
  if (requireActive && user.status !== "active" && user.role !== "admin")
    return <Navigate to="/register" replace />;
  return children;
}
